import { observer } from "mobx-react-lite";
import { Button, Icon, Input, Table } from "semantic-ui-react";
import React from "react";
import { useAgeReadyContext } from "../../../AgeReadyContext/AgeReadyContext";

interface DocumentRowProps {  
  obj: any;
  btnLoading: string;
  deleteDoc: (docId: string, docName: string, caregiverId: string, recipientId: string) => void;
  downloadDoc: (docId: string, docName: string, caregiverId: string, recipientId: string, docType: string) => void;
}

const DocumentRow: React.FC<DocumentRowProps> = (props) => {
  const { obj, btnLoading, deleteDoc, downloadDoc } = props;
  const { documentInfoStore } = useAgeReadyContext();

  const onDelete = (docId: string, docName: string, caregiverId: string, recipientId: string) => {
    deleteDoc(docId, docName, caregiverId, recipientId);
  };
  const onDownload = (docId: string, docName: string, caregiverId: string, recipientId: string, docType: string) => {
    downloadDoc(docId, docName, caregiverId, recipientId, docType);
  };

  const getFileTypeIconName = (fileType: string) => {
    if (fileType.includes("pdf")) { return "file pdf outline"; }
    else if (fileType.includes("word") || fileType.includes("document")) { return "file word outline"; }
    else if (fileType.includes("spreadsheet") || fileType.includes("excel")) { return "file excel outline"; }
    else if (fileType.includes("powerpoint") || fileType.includes("presentation")) { return "file powerpoint outline"; }
    else if (fileType.includes("image")) { return "file image outline"; }
    else if (fileType.includes("audio")) { return "file audio outline"; }
    else if (fileType.includes("video")) { return "file video outline"; }
    else if (fileType.includes("text")) { return "file alternate outline"; }
    else { return "file outline"; }
  }
  
  const renderFileTypeIcon = (fileType: string) => {
    const iconName = fileType ? getFileTypeIconName(fileType) : 'file outline';
    return (
      <>
        <Icon name={iconName} size='big' key={`filetype_${obj.key}`}  />
      </>
    )
  }

  return (
    <>
      <Table.Row id={`rowid_${obj.key}`}  key={obj.key} >
        <Table.Cell >
          {renderFileTypeIcon(obj.fileType)}
        </Table.Cell>
        <Table.Cell style={{ minWidth: "150px" }}>
          <Input
            fluid
            transparent
            name={`filename_${obj.key}`} 
            key={`filename_${obj.key}`} 
            placeholder="Unable to get file name."
            value={obj.fileName}
          />
        </Table.Cell>
        <Table.Cell style={{ minWidth: "102px" }}>
          <Input
            fluid
            transparent
            name={`uploadedon_${obj.key}`} 
            key={`uploadedon_${obj.key}`} 
            value={obj.uploadedOn}
          />
        </Table.Cell>
        <Table.Cell >
          <div style={{ minWidth: "75px" }} >
            <Button
              name={`delete_${obj.key}`} 
              key={`delete_${obj.key}`} 
              onClick={() => onDelete(obj.documentId, obj.fileName, obj.caregiverId, obj.recipientId)}
              compact
              size="tiny"
              icon="trash"
              loading={documentInfoStore.isLoading && btnLoading === "delete"}
              disabled={documentInfoStore.isLoading}
            />
            <Button
              name={`download_${obj.key}`} 
              key={`download_${obj.key}`} 
              onClick={() => onDownload(obj.documentId, obj.fileName, obj.caregiverId, obj.recipientId, obj.fileType)}
              compact
              size="tiny"
              icon="download"
              loading={documentInfoStore.isLoading && btnLoading === "download"}
              disabled={documentInfoStore.isLoading}
            />
          </div>
        </Table.Cell>
      </Table.Row>
    </>
  );
};

export default observer(DocumentRow);
